"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
exports.shareTextToWhatsApp = (text) => {
    window.location.href = `${util_1.getWhatsAppBaseUrl()}?text=${util_1.urlEncodeText(text)}`;
};
exports.getWhatsAppClickToChatLink = (text) => {
    return `${util_1.getWhatsAppBaseUrl()}?text=${util_1.urlEncodeText(text)}`;
};
exports.hasNativeSharingSupport = () => {
    if (navigator.share) {
        return true;
    }
    return false;
};
exports.shareTextViaNativeSharing = (data, fallbackFunction) => __awaiter(this, void 0, void 0, function* () {
    try {
        yield navigator.share(data);
    }
    catch (err) {
        if (typeof fallbackFunction === 'function') {
            fallbackFunction();
        }
    }
});
